export enum Mode {
    Filter = "filter",
    Matno = "matno",
    MatnoReduced = "matno-reduced",
}

export default interface Config {
    mode: Mode;
    initialChunkSize: number;
    chunkSize: number;
    initialSorting: string;
    sortOptions: Array<string>;
};
